import React from "react";
import FinancialReportPage from "../Reports/FinancialReportPage";

const ReportExpensePage = () => <FinancialReportPage type="purchases" />;

export default ReportExpensePage;
